<template>
    <Paper :header="label">
        <LayoutToggles v-if="withLayoutToggle" slot="header" v-model="isList" />
        <div slot="header" v-if="chatFilterButton && chatAvailability.length">
            <BaseButton class="w-100 centered" variant="primary" @click="toggleChatFilter">
                {{ chatFilterToggle ? 'Show all companies' : 'Show only companies live on chat' }}
            </BaseButton>
        </div>
        <div v-if="data.length > 0" :class="{ grid: !isList && !forceList }">
            <div
                v-for="company in getData()"
                :key="company.id"
                v-b-tooltip.hover
                :title="company.name"
                style="background-color: white"
            >
                <router-link :to="gotoCompany(company.id)" style="text-decoration:none;">
                    <div
                        class="h-100 clickable px-2 py-2"
                        :class="[
                            isList ? 'company-list-item' : 'company-grid-item',
                            isList && 'pr-4',
                        ]"
                    >
                        <PulsatingDot
                            v-if="hasChatUsersActive(company.id)"
                            class="live-pulsator"
                            :text="$t('shared.chat.liveNow')"
                        />
                        <b-img
                            class="image-default"
                            :src="company.logo"
                            fluid
                            style="grid-row: span 2; align-self: center; justify-self: center;"
                        ></b-img>
                    </div>
                </router-link>
            </div>
        </div>

        <div v-if="isLoading" class="py-2">
            <ListItemSkeleton v-for="i in 4" :key="i" :rows="3" small />
        </div>
        <div v-else-if="data.length === 0">
            <slot />
        </div>
    </Paper>
</template>

<script>
// Project components
import LayoutToggles from './LayoutToggles';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton';
import PulsatingDot from '../components/miscellaneous/PulsatingDot';

export default {
    name: 'CompanyList',
    components: {
        PulsatingDot,
        LayoutToggles,
        ListItemSkeleton,
    },
    props: {
        label: String,
        withLayoutToggle: Boolean,
        isLoading: Boolean,
        data: {
            type: Array,
            default: () => [],
        },
        chatAvailability: {
            type: Array,
            default: () => [],
        },
        resolveroute: {
            type: Function,
        },
        chatFilterButton: Boolean,
        forceList: Boolean,
    },
    data: () => ({
        isList: false,
        chatFilterToggle: false,
    }),
    methods: {
        getData() {
            if (this.chatFilterToggle) {
                return this.data.filter(item => {
                    return this.chatAvailability.filter(chatItem => chatItem.id === '' + item.id)
                        .length;
                });
            }
            return this.data;
        },
        gotoCompany(id) {
            if (this.resolveroute !== undefined) {
                return this.resolveroute(id);
            } else {
                const url = this.$URLS.findcompanies.concat('/', id);
                return url;
            }
        },
        hasChatUsersActive(id) {
            return (
                this.chatAvailability.filter(item => item.id === '' + id && item.count > 0).length >
                0
            );
        },
        toggleChatFilter() {
            this.chatFilterToggle = !this.chatFilterToggle;
        },
    },
};
</script>

<style scoped>
.grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    background-color: #f3f3f3;

    grid-gap: 1px;
}
.company-list-item {
    display: grid;
    grid-template-rows: 50px 50px;
    grid-template-columns: repeat(auto);
    max-width: 100%;
    grid-column-gap: 1rem;
    grid-auto-flow: column;
    position: relative;
}

.company-list-item .live-pulsator {
    margin: 10px;
}

.company-grid-item {
    display: grid;
    grid-template-rows: repeat(auto);
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    grid-column-gap: 1rem;
    grid-row-gap: 0.2rem;
    text-align: center;
    min-height: 160px;
}
/*.company-grid-item > *:nth-child(1) {
    padding-bottom: 20px;
    padding-top: 20px;
}*/
.company-grid-item > *:nth-child(-n + 3) {
    grid-column: span 2;
}
.company-grid-item > *:nth-child(2n + 5) {
    align-self: center;
    justify-self: center;
}

@media only screen and (max-width: 600px) {
    .grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
    .company-list-item {
        grid-template-columns: 100px fit-content(100%) minmax(auto, 1fr) minmax(auto);
    }
    h5 {
        font-size: 14px;
    }
}

@media only screen and (max-width: 370px) {
    .grid {
        grid-template-columns: 1fr 1fr;
    }
}

.company h5 {
    align-self: end;
    margin-bottom: 0;
}
.company h6 {
    margin-bottom: 0;
}

.divider {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
.image-default {
    max-width: 90px !important;
}
</style>
